import { DateTime } from 'luxon';

export enum UserRole {
  ADMIN = 'admin',
}

export interface IUser {
  readonly authuser: boolean;
  // Profile
  id: string;
  orgId: string;
  email: string;
  firstName: string;
  lastName: string;
  latest: null | string | DateTime;
  nativeLocale: string;
  roles: UserRole[];
  verified: boolean;
  cohortId: null | string;
  courseId: null | string;
  courseList: string[];
  createdAt: null | string | DateTime;
  // Signin appended
  cohort: any;
  courses: any[];
}

export class User implements IUser {
  readonly authuser: boolean = false;
  // Profile
  id = '';
  orgId = '';
  email = '';
  firstName = '';
  lastName = '';
  latest: null | string | DateTime = null;
  nativeLocale = '';
  roles: UserRole[] = [];
  verified = false;
  cohortId: null | string = null;
  courseId: null | string = null;
  courseList: string[] = [];
  createdAt: null | string | DateTime = null;
  // Signin appended
  cohort: any = null;
  courses: any[] = [];

  constructor(incoming?: IUser) {
    if (incoming) {
      Object.assign(this, incoming);
      if (incoming.latest && typeof incoming.latest === 'string') {
        this.latest = DateTime.fromISO(incoming.latest).toUTC();
      }
      if (incoming.createdAt && typeof incoming.createdAt === 'string') {
        this.createdAt = DateTime.fromISO(incoming.createdAt).toUTC();
      }
    }
  }
}
